<div class="container-fluid">
  <div class="row dark py-2">
    <div class="col-md-12 header-center">
      <h3>PROFILE</h3>
      <div>
        <p class="separator"></p>
      </div>
    </div>
  </div>
  <div class="row dark">
    <div class="col-md-4">
      <div class="card text-center dark border-warning mb-3 text-white">
        <div class="card-header border-warning">
          <b>Details</b>
        </div>
        <div class="card-body">
          <p class="card-text">
            <li>Name: Rohit Rana</li>
            <li>Age: {{ age }} Years</li>
            <li>Location: Pune, Maharashtra</li>
            <li>
              Email: <a href="mailto:rohit.rana0207@gmail.com"> {{ userEmail }} </a>
            </li>
          </p>
        </div>
      </div>
    </div>

    <div class="col-md-8">
      <div class="card text-center dark border-warning mb-3 text-white">
        <div class="card-header border-warning">
          <b>About Me</b>
        </div>
        <div class="card-body">
          <p class="card-text">
            <li>
              I am Full stack web developer. I love structure and order and I also stand out for
              quality.
            </li>
            <li>I love spending time in problem solving and developing new webapps.</li>
            <li>
              I also like working in a team, you'll learn faster and more, as the saying goes: 'two
              heads are better than one'.
            </li>
            <li>
              I like to explore new Technologies and always strive to learn and try something new
              everyday.
            </li>
          </p>
          <a [href]="resumeUrlName" target="_blank" download>
            <button class="btn btn-resume">DOWNLOAD RESUME</button>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="row dark py-2">
    <div class="col-md-12 header-center">
      <h3>EXPERIENCES</h3>
      <div>
        <p class="separator"></p>
      </div>
    </div>
  </div>

  <div
    *ngFor="let edu of educationList; let first = first"
    class="row dark noPad text-white py-3 d-center"
  >
    <div class="col-md-2">
      <h4 *ngIf="first">{{ edu.heading }}</h4>
    </div>
    <div class="col-md-5">
      <h5>{{ edu.degree }}</h5>
      <p>{{ edu.institution }}</p>
    </div>
    <div class="col-md-4">
      <p class="italic">{{ edu.year }}</p>
    </div>
  </div>

  <div
    *ngFor="let exp of experienceList; let first = first"
    class="row dark noPad text-white d-center"
  >
    <div class="col-md-2">
      <h4 *ngIf="first">{{ exp.heading }}</h4>
    </div>
    <div class="col-md-5">
      <h5>{{ exp.company }}</h5>
      <p [ngClass]="{ 'text-warning': exp.role === 'Founder, CEO' }">
        <i class="bi bi-check-circle-fill" *ngIf="exp.role === 'Founder, CEO'"></i> {{ exp.role }}
      </p>
    </div>
    <div class="col-md-4">
      <p class="italic">{{ exp.year }}</p>
    </div>
  </div>
</div>
